import mod from "-!./ToolComparison.js?vue&type=script&lang=js&"; export default mod; export * from "-!./ToolComparison.js?vue&type=script&lang=js&"